/**
 * 门店空图标
 */
const EmptyStoreIcon = ({ width = 90, height = 90 }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 90 90" fill="none">
      <rect width="90" height="90" fill="white" />
      <path d="M22 68H68L68.5 39H21.5L22 68Z" fill="#BBBBBD" />
      <path d="M34 68H45V54H34V68Z" fill="#F8F8F9" />
      <path d="M69 21H21.5L17.5 39H21.5H68.5H72.5L69 21Z" fill="#F3F3F4" />
    </svg>
  )
}

export default EmptyStoreIcon
